import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { OrganizationsRes, UserProfileRes } from '../api.abstraction';
import { ApiEndpoint } from '../api.constant';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  private readonly http = inject(HttpClient);

  getOrganizations(): Observable<OrganizationsRes> {
    return this.http.get<OrganizationsRes>(
      `${environment.apiHost}/${ApiEndpoint.Organizations}`,
    );
  }

  getProfile(): Observable<UserProfileRes> {
    return this.http.get<UserProfileRes>(
      `${environment.apiHost}/${ApiEndpoint.UserProfile}`,
    );
  }
}
